import axios from 'axios'
import { BASE_API_URL, UPLOAD_CSV_ENDPOINT } from './api'

export const uploadCSV = async (params: { token: string; file: File }) => {
  const { file, token } = params
  const form: any = new FormData()
  form.append('file', file)
  return axios
    .post(`${BASE_API_URL}/${token}${UPLOAD_CSV_ENDPOINT}`, form, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => response.data)
}
